var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-footer',{staticClass:"footer",attrs:{"footer-bg-variant":"dark"}},[_vm._v(" Copyright 2020, Willian Nascimento® ")])}
var staticRenderFns = []

export { render, staticRenderFns }